import type { TextNode } from '@blissbook/lib/document/types'
import type { NodeViewerComponent } from '.'
import { MarksViewer } from '../marks'

export const TextNodeViewer: NodeViewerComponent = ({ node }) => {
  const { marks, text } = node as TextNode
  return <MarksViewer marks={marks}>{text}</MarksViewer>
}
